import { goToUrl } from "apps/visits/core/utils/go-to-url";
import type { AxiosError } from "axios";
import { t } from "i18next";
import type { RegistrationErrorResponse } from "../../api/group-actions-ordering.types";
import { routes } from "../../config/routes";
import type { ErrorDetail } from "../../types";

const isUniquenessError = (arr: ErrorDetail[]) => {
  if (!arr) return false;
  return arr.filter((err) => err.error === "taken").length > 0;
};

export const extractRegistrationErrorType = (
  error: AxiosError<RegistrationErrorResponse> | null | undefined,
): string => {
  if (!error) return "unknown";
  const body = error.response?.data?.error;
  if (!body) return "unknown";

  if (body.estimated_number_of_patients) return "patients_limit_reached";
  if (body.base?.some((errorObj) => errorObj.error === "code_expired")) return "code_expired";
  if (body.email && isUniquenessError(body.email)) return "email_taken";
  if (body.phone && isUniquenessError(body.phone)) return "phone_taken";
  return "unknown";
};

export const handleRegistrationApiErrors = (
  error: AxiosError<RegistrationErrorResponse> | null,
): string | undefined => {
  if (!error) return undefined;

  const registrationError = error?.response?.data?.error;
  const codeExpiredError = registrationError?.base?.filter((errorObj) => errorObj.error === "code_expired");

  if (registrationError?.estimated_number_of_patients) {
    goToUrl(routes.limitReached.raw());
    return undefined;
  }

  if (codeExpiredError && codeExpiredError.length > 0) return t("GROUP_ACTIONS_ORDERING.ERRORS.CODE_VALIDATION_ERROR");

  if (registrationError?.email) {
    const uniqueEmailError = isUniquenessError(registrationError.email);
    if (uniqueEmailError) return t("GROUP_ACTIONS_ORDERING.ERRORS.REGISTRATION_UNIQUE_ERROR");
  }

  if (registrationError?.phone) {
    const uniqueEmailError = isUniquenessError(registrationError.phone);
    if (uniqueEmailError) return t("GROUP_ACTIONS_ORDERING.ERRORS.REGISTRATION_UNIQUE_ERROR");
  }

  return t("COMMONS.ERRORS.GENERAL_API_ERROR");
};
